import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getPointsCount } from '@wix/da-shared-react/pkg/publicSession/selectors';
import FooterLink from '../FooterLink';
import s from './PointsFooter.scss';
const PointsFooter = ()=>{
    const { t } = useTranslation('dreamup');
    const balance = useSelector(getPointsCount);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['balance']
    }, t('dreamup.modal.points.card.balance', {
        count: balance
    })), /*#__PURE__*/ React.createElement("span", {
        className: s['links']
    }, /*#__PURE__*/ React.createElement(FooterLink, {
        href: t('dreamup.modal.points.footer.termsLink.url')
    }, t('dreamup.modal.points.footer.termsLink.text')), ' ', "|", ' ', /*#__PURE__*/ React.createElement(FooterLink, {
        href: t('dreamup.modal.points.footer.learnMoreLink.url')
    }, t('dreamup.modal.points.footer.learnMoreLink.text'))));
};
PointsFooter.displayName = 'PointsFooter';
export default PointsFooter;

//# sourceMappingURL=PointsFooter.js.map